import React, { Component } from 'react'
import {
  MessageComponentProps,
  MessageBubble,
  MessageBubbleText,
  FirebaseMessage
} from '@deal/chat-firebase'
import CurationIcon from './curation.svg'
import { SimpleCuratedOrderRichCardComponent, MessageRichCardType } from '#src/generated/graphql'
import styles from './styles.css'
import numeral from 'numeral'
import { Link } from 'react-router-dom'
import { OrderState } from '../../../generated/graphql'
import { Image } from '@deal/components'

export default class SimpleCuration extends Component<MessageComponentProps> {
  public static handlesMessage(message: FirebaseMessage) {
    return (
      message.parts[0].type == 'TEMPLATE_CAROUSEL' &&
      message.parts[0].body.richCardType == MessageRichCardType.SIMPLE_CURATED_ORDER &&
      message.parts[0].body.queryVariables &&
      message.parts[0].body.queryVariables.simpleCuratedOrderId
    )
  }

  public render() {
    const orderId = this.props.message.parts[0].body.queryVariables.simpleCuratedOrderId

    return (
      <SimpleCuratedOrderRichCardComponent variables={{ id: orderId }}>
        {({ data, loading }) => {
          if (loading) {
            return (
              <MessageBubbleText message={this.props.message} myself={this.props.myself}>
                Loading ...
              </MessageBubbleText>
            )
          } else if (data && data.simpleCuratedOrder) {
            const curatedByExpert = data.simpleCuratedOrder.curator.firstName
            const orderPaid =
              data.simpleCuratedOrder.order.state == OrderState.CONSUMER_PAYMENT_COMPLETED
            const category = data.simpleCuratedOrder.lead && data.simpleCuratedOrder.lead.category
            const banner =
              category &&
              category.contentAssets.bannerImages &&
              category.contentAssets.bannerImages[0]
            const amount = numeral(data.simpleCuratedOrder.order.totalCost.amount).format('$0,0')
            return (
              <MessageBubble message={this.props.message}>
                <div className={styles.hero}>
                  <div className={styles.hero}>
                    {banner && (
                      <Image
                        src={banner.imageUrl!}
                        width={384}
                        height={134}
                        imgixParams={{ fit: 'crop' }}
                        className={styles.heroImage}
                        onMounted={this.props.onLoaded}
                      />
                    )}
                    <div className={styles.overlay}>
                      <div className={styles.fee}>Consultation fee</div>
                      <ul className={styles.lists}>
                        <li>The {amount} goes towards your purchase</li>
                        <li>
                          If you don't buy, 100% of the fee goes to {curatedByExpert} for helping
                          you out
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className={styles.caption}>
                  <CurationIcon className={styles.curationIcon} />
                  {amount} consultation fee
                </div>
                {orderPaid ? (
                  <div className={styles.cta}>Paid</div>
                ) : (
                  <Link
                    to={`/orders/${data.simpleCuratedOrder.order.id}/checkout`}
                    className={styles.cta}
                  >
                    Pay fee
                  </Link>
                )}
              </MessageBubble>
            )
          } else {
            return (
              <MessageBubbleText message={this.props.message} myself={this.props.myself}>
                Error loading messages!
              </MessageBubbleText>
            )
          }
        }}
      </SimpleCuratedOrderRichCardComponent>
    )
  }
}
